import React, { useEffect, useState } from "react";
import Dashboard from "../../Dashboard";
import { useMediaQuery } from "@mui/material";
import { getUser } from "../../utils/common";
import { useDispatch } from "react-redux";
import AttandanceTable from "../../tables/AttandanceTable";
import { getAllAttandanceAction, getAttandanceByTeammemberIdAction } from "../../../store/settings/actions";
import { DatePicker, Input } from "antd";
import dayjs from "dayjs";
const { Search } = Input;
const { RangePicker } = DatePicker;

const AttandanceManagement = () => {
  const dispatch = useDispatch();
  const currentDate = new Date().toISOString().slice(0, 10);

  const isTablet = useMediaQuery("(max-width: 960px)");
  const user = getUser();
  const findRole = user[0]?.roles[0]?.permissions;
  const permissions = [];
  findRole?.map((item) => permissions?.push(item.permissions));

  const [selectedDates, setSelectedDates] = useState([currentDate, currentDate]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (["", null, undefined]?.includes(search)) {
      if (user[0]?.type === "BARBER_B") {
        getAttandanceByTeammemberIdAction(user[0]?._id, `?startDate=${selectedDates[0]}&endDate=${selectedDates[1]}`)(dispatch);
      } else {
        getAllAttandanceAction(`?startDate=${selectedDates[0]}&endDate=${selectedDates[1]}`)(dispatch);
      }
    }
  }, [dispatch, selectedDates, search]);

  const handleSerch = () => {
    if (user[0]?.type === "BARBER_B") {
      getAttandanceByTeammemberIdAction(user[0]?._id, `?search=${search}`)(dispatch);
    } else {
      getAllAttandanceAction(`?search=${search}`)(dispatch);
    }
  };

  const onChangeDate = (dates, dateStrings) => {
    if (dateStrings) {
      setSelectedDates(dateStrings);
    }
  };

  const isBarberB = user && user.length > 0 && user[0]?.type === "BARBER_B";

  return (
    <Dashboard>
      <div className={`content-body mt-[3rem] ${!isTablet && !isBarberB && "ml-52"}`}>
        <div className="container-fluid">
          <div
            className={`relative form-head mb-3 flex items-center justify-between`}
          >
            <div className="mr-auto d-lg-block">
              <h3 className="text-black font-w500 mb-6">Attandence</h3>
            </div>
          </div>

          <div className="mb-4 flex items-center justify-between">
            <RangePicker
              defaultValue={[dayjs(), dayjs()]}
              allowClear={false}
              className="h-10 w-64"
              onChange={onChangeDate}
            />
            <Search
              placeholder="Search by first-name or last-name"
              onChange={(e) => setSearch(e.target.value)}
              enterButton
              size="large"
              className="w-80"
              onSearch={handleSerch}
            />
          </div>

          <div className="row">
            <div className="col-12">
              <AttandanceTable selectedDates={selectedDates} />
            </div>
          </div>
        </div>
      </div>
    </Dashboard>
  );
};

export default AttandanceManagement;
